import { deviceTableBodyMap } from './device/mapper';
import { projectTableBodyMap } from './project/mapper';
import { userTableBodyMap } from './user/mapper';
import { shipmentTableBodyMap } from './shipment/mapper';
import { tableNameType } from '#type';

export const tableMap = {
  [tableNameType.DEVICE_TABLE]: deviceTableBodyMap,
  [tableNameType.PROJECT_TABLE]: projectTableBodyMap,
  [tableNameType.USER_TABLE]: userTableBodyMap,
  [tableNameType.SHIPMENT_TABLE]: shipmentTableBodyMap
};
